let BASE_URL = "https://www.chemical-link.com";
let IMAGE_URL = "";



let config = {
	BASE_URL:BASE_URL+'/api',
	IMG_URL:IMAGE_URL,
	UPLOAD_PATH:BASE_URL + "/index/Upload/upload",
	YX_APPKEY:"e0c2a15491308fe90d3aec04f9025d45",
	WECHAT_OPEN_APPID:"wx33909e8ecfc78fd4",
}

export default config;
